import * as moment from "moment";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ICalendarEventEditorState } from "../ICalendarEventEditorState";

export function Increment({
    state,
    setState,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
}) {
    if (state.calendarEvent.name === `` || state.calendarEvent.isRepeating) {
        return null;
    }

    return (
        <div style={{ opacity: 0.65 }}>
            <IconWithText
                iconSuffix={EGlyphicon.plus}
                whenClicked={() => {
                    const newStartTime = moment(state.calendarEvent.start)
                        .add(1, "hours")
                        .format();

                    const newEndTime = moment(state.calendarEvent.end)
                        .add(1, "hours")
                        .format();

                    setState({
                        ...state,
                        calendarEvent: {
                            ...state.calendarEvent,
                            start: newStartTime,
                            end: newEndTime,
                        },
                    });
                }}
                displayAsBlock
            >
                increment
            </IconWithText>
        </div>
    );
}
